/* eslint-disable */
import Component from 'gia/Component'
import slick from 'slick-carousel'

export default class ComponentTeamSlider extends Component {
  constructor(element) {
    super(element)
  }

  teamSliderSetup() {
    $(this.element).each(function() {
      $(this)
        .find('.team-slider__wrapper')
        .slick({
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: true,
          dots: true,
          infinite: false,
          appendDots: '.team-slider__slick-dots',
          appendArrows: '.team-slider__slick-arrows',
          prevArrow:
            '<div class="team-slider__next"><svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg"><path d="M9.621 13.966c.505.465.505 1.22 0 1.686a1.383 1.383 0 01-1.834 0L.379 8.843a1.128 1.128 0 010-1.686L7.787.348a1.383 1.383 0 011.834 0c.505.466.505 1.22 0 1.686L3.126 8.003l6.495 5.963z" fill="#49A27C" fill-rule="evenodd"/></svg></div>',
          nextArrow:
            '<div class="team-slider__prev"><svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg"><path d="M.379 13.966a1.128 1.128 0 000 1.686 1.383 1.383 0 001.834 0l7.408-6.809a1.128 1.128 0 000-1.686L2.213.348a1.383 1.383 0 00-1.834 0 1.128 1.128 0 000 1.686l6.495 5.969-6.495 5.963z" fill="#49A27C" fill-rule="evenodd"/></svg></div>',
          responsive: [
            {
              breakpoint: 1232,
              settings: {
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 768,
              settings: {
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        })
    })
  }

  mount() {
    this.teamSliderSetup()
  }
}



// WEBPACK FOOTER //
// ./scripts/components/TeamSlider.js